<template>
  <div class="layout-box">
    <LayoutHeader></LayoutHeader>
    <div class="bf_bj">
      <video width="100%" height="100%" style="margin-left: 0" crossorigin="anonymous" autoplay preload="auto" muted="muted" loop playsinline webkit-playsinline="true" src="../../assets/bjsp.mp4"></video>
    </div>
    <div class="ss_c">
      <div class="ss-k">
        <input>
        <span>检索一下</span>
      </div>
      <div class="erci">
        <span>智能热搜 ></span>
        <ul>
          <li>1 产业地图</li>
          <li>1 产业地图</li>
          <li>1 产业地图</li>
          <li>1 产业地图</li>
          <li>1 产业地图</li>
          <li>2 化纤运行数据<i class="re">热</i></li>
          <li>2 化纤运行数据</li>
          <li>2 化纤运行数据</li>
          <li>2 化纤运行数据</li>
          <li>2 化纤运行数据</li>
          <li>3 聚酯今日指数<i class="re bo">爆</i></li>
          <li>3 聚酯今日指数</li>
          <li>3 聚酯今日指数</li>
          <li>3 聚酯今日指数</li>
          <li>3 聚酯今日指数</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header";

export default {
  name: 'SearchIndex',
  components:{
    LayoutHeader
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
}
.bf_bj{
  position: fixed;
  z-index: 1;
  width: 120%;
  height: 120%;
  transform: translateX(-208px) translateY(-180px) rotate(0deg);
  transform-origin: center center;
}
.ss_c{
  width: 100%;
  height: 100%;
  z-index: 12;
  position: absolute;
  overflow: hidden;
  top: -10%;
  left: 0;
  display: flex;
  justify-content:center;
  align-items:center;
  flex-direction:column;
}
.ss-k{
  height: 47px;
}
.ss-k input{
  width: 520px;
  height: 41px;
  line-height: 41px;
  font-size: 14px;
  color: #333;
  padding: 0 12px;
  border: 3px solid #034ADE;
  border-bottom-left-radius: 9px;
  border-top-left-radius: 9px;
  float: left;
}
.ss-k span{
  width: 102px;
  height: 41px;
  border: 3px solid #034ADE;
  border-bottom-right-radius: 9px;
  border-top-right-radius: 9px;
  background: #034ADE;
  font-size: 18px;
  color: #fff;
  line-height: 41px;
  text-align: center;
  float: left;
  font-weight: bold;
  cursor: pointer;
}
.ss-k span:hover{
  background: #0250F2;
}
.erci{
  margin-top: 30px;
  width: 750px;
  padding: 10px 5px;
  background: rgba(2,45,130,.68);
}
.erci span{
  font-size: 18px;
  display: block;
  color: #fff;
  font-family: 华文隶书;
  padding: 10px 12px;
}
.erci li{
  float: left;
  font-size: 14px;
  color: #fff;
  width: 115px;
  font-family: 微软雅黑;
  margin: 10px 15px;
  cursor: pointer;
}

.erci li:hover{
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  font-weight: bold;
  text-decoration:underline;
}

.re{
  width: 16px;
  height: 17px;
  line-height: 17px;
  font-size: 11px;
  color: #fff;
  background: #FF6600;
  border-radius: 2px;
  display: inline-block;
  margin-left: 2px;
}
.bo{
  background: #DE1544;
}

</style>



// WEBPACK FOOTER //
// src/views/search/search-index.vue